<template>
  <v-card class="d-flex flex-column align-center justify-center pa-5">
    <v-card-title class="mb-5">Επεξεργασία Εργαζομένου</v-card-title>
    <v-form class="form d-flex flex-column justify-center">
      <v-text-field
        label="Όνομα"
        v-model="name"
        :error-messages="nameErrors"
        class="rounded text-body-1 font-weight-regular"
      >
      </v-text-field>

      <v-text-field
        label="Επίθετο"
        v-model="lastName"
        :error-messages="lastNameErrors"
        class="rounded text-body-1 font-weight-regular"
      >
      </v-text-field>

      <v-text-field
        label="Email"
        v-model="email"
        :error-messages="emailErrors"
        class="rounded text-body-1 font-weight-regular"
      >
      </v-text-field>

      <v-text-field
        label="Username"
        v-model="userName"
        :error-messages="userNameErrors"
        class="rounded text-body-1 font-weight-regular"
      >
      </v-text-field>

      <v-radio-group label="Σύνδεση" v-model="canLogin">
        <v-radio label="Επιτρέπεται" :value="true"></v-radio>
        <v-radio label="Απογορεύεται" :value="false"></v-radio>
      </v-radio-group>

      <v-select
        v-model="select"
        class="mb-6"
        :items="creditInstitutes"
        item-value="creditInstituteId"
        item-text="mmfManagerNationalName"
        attach
        chips
        label="ΑΕΔΑΚ"
        multiple
        :menu-props="{ top: true }"
      ></v-select>

      <div class="d-flex justify-center mt-16">
        <v-btn
          class="success rounded text-sm-body-1 font-weight-regular mr-5"
          :loading="loader"
          @click="onSubmit"
        >
          <span>Επεξεργασία</span>
        </v-btn>
        <v-btn
          class="secondary rounded text-sm-body-1 font-weight-regular"
          @click="$emit('closeDialog')"
        >
          <span>Επιστροφή</span>
        </v-btn>
      </div>
    </v-form>
  </v-card>
</template>

<script>
import axios from "axios";

import {
  required,
  requiredIf,
  email,
  sameAs,
  minLength,
  maxLength,
} from "vuelidate/lib/validators";

export default {
  props: {
    currentUser: Object,
  },

  async created() {
    await this.getCreditInstitutes();

    this.name = this.currentUser?.user?.firstName;
    this.lastName = this.currentUser?.user?.lastName;
    this.canLogin = this.currentUser?.user?.canLogin;
    this.userName = this.currentUser?.user?.userName;
    this.email = this.currentUser?.user?.userEmail;

    this.select = this.currentUser.creditInstitutes.map(
      (el) => el.creditInstituteId
    );
  },

  data() {
    return {
      name: "",
      lastName: "",
      email: "",
      password: "",
      passwordConfirmation: "",
      userName: "",

      creditInstitutes: [],

      canLogin: true,
      select: [],
      loader: false,
    };
  },

  validations: {
    name: {
      required,
      minLength: minLength(3),
      maxLength: maxLength(16),
    },
    lastName: {
      required,
      minLength: minLength(3),
      maxLength: maxLength(16),
    },

    email: {
      required,
      email,
    },
    userName: {
      required,
    },
  },

  computed: {
    nameErrors() {
      const errors = [];
      if (!this.$v.name.$dirty) return errors;
      if (!this.$v.name.required) errors.push("Υποχρεωτικό πεδίο");
      if (!this.$v.name.minLength) errors.push("Τουλάχιστον 3 χαρακτήρες");
      if (!this.$v.name.maxLength) errors.push("Μέχρι 16 χαρακτήρες");
      return errors;
    },

    lastNameErrors() {
      const errors = [];
      if (!this.$v.lastName.$dirty) return errors;
      if (!this.$v.lastName.required) errors.push("Υποχρεωτικό πεδίο");
      if (!this.$v.lastName.minLength) errors.push("Τουλάχιστον 3 χαρακτήρες");
      if (!this.$v.lastName.maxLength) errors.push("Μέχρι 16 χαρακτήρες");
      return errors;
    },

    userNameErrors() {
      const errors = [];
      if (!this.$v.userName.$dirty) return errors;
      if (!this.$v.userName.required) errors.push("Υποχρεωτικό πεδίο");

      return errors;
    },

    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      if (!this.$v.email.required) errors.push("Υποχρεωτικό πεδίο");
      if (!this.$v.email.email) errors.push("Το email δεν είναι έγκυρο");

      return errors;
    },
  },

  methods: {
    async getCreditInstitutes() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_BASE_URL}/admin/GetCreditInstitutes`
        );
        this.creditInstitutes = res.data;
      } catch (e) {
        console.log(e);
      }
    },

    async onSubmit() {
      try {
        this.$v.$touch();
        if (this.$v.$invalid) return;
        this.loader = true;

        const payload = {
          hcmcEmployeeId: this.currentUser.hcmcEmployeeId,
          user: {
            firstName: this.name,
            lastName: this.lastName,
            userName: this.userName,
            userEmail: this.email,
            canLogin: this.canLogin,
            userRole: "hcmc",
            creditInstituteIds: this.select,
          },
        };

        if (this.password != null) {
          payload.user["userPassword"] = this.password;
        }

        await axios.post(
          `${process.env.VUE_APP_BASE_URL}/admin/UpdateHCMCEmployeeNew`,
          payload
        );

        await this.$emit("getUsers");
        this.loader = false;

        this.$store.commit("toggleSnackbar", {
          open: true,
          color: "success",
          text: "Η επεξεργασία εργαζομένου ολοκληρώθηκε με επιτυχία!",
        });
        this.$emit("closeDialog");
      } catch {
        this.loader = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.form {
  width: 500px;
}
</style>